import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let SubheaderComp;

class Sub_header extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: SubheaderComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/subheader-comp" */
      "../../../components/javascript/zcat-components/subheader-comp"
    ).then(function(res) {
      SubheaderComp = res.SubheaderComp;
    }));

    
;
  }
}

export { Sub_header };
